module.exports = __webpack_public_path__ + "img/PayPal-SCLIP.228b84f3.jpg";